import React, { Fragment, useEffect, useState } from "react";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
// import I18n from "pages/_components/I18n";

import { actions as discountsActions } from "reducers/discounts";
import { actions as accountsActions } from "reducers/accounts";
// import { actions as formActions } from "reducers/form";
// import { useParams } from "react-router-dom";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
// import CustomHead from "pages/_components/CustomHead";
// import Button from "pages/_components/Button";
import Credential from "pages/_components/fields/credentials/Credential";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Checkbox from "pages/_components/Checkbox";

// eslint-disable-next-line import/no-named-as-default
import EcheqTransactionCard, {
    EcheqTransactionHeader,
    EcheqTransactionSign,
} from "pages/_components/EcheqTransactionCard";
import Button from "pages/_components/Button";

import { useSelector, useDispatch } from "react-redux";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import * as configUtils from "util/config";
import { bool, shape } from "prop-types";
import { ResponsiveHeader } from "pages/_components/header";
import gaEventTracker, { events } from "util/gaEventTracker";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";

const NewDiscountPendingTransaction = ({ transaction, isDesktop }) => {
    const dispatch = useDispatch();
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const [showMoreData, setShowMoreData] = useState(false);

    const account = useSelector((_state) => _state.accounts?.selectedAccount);
    const fetchingAccount = useSelector((_state) => _state.accounts?.fetching);
    const discountTicket = useSelector((_state) => _state.discounts?.discountTicket);
    const { status: discountTicketStatus, idTransaction: discountTicketId } = discountTicket;
    const discountRequiredCredentials = useSelector((_state) => _state.discounts?.discountRequiredCredentials);
    const [accountLabel, setAccountLabel] = useState(null);
    const isLoading = !transaction?.data || fetchingAccount || !discountRequiredCredentials;
    const finalEcheqs = transaction?.data?.echeqs || [];
    const closingHour = configUtils.get("bibank.closingHour", "18");
    const idUser = useSelector((_state) => _state.session?.user?.userId);
    const discountTicketSignable = !!idUser && transaction?.signatures?.every((sign) => sign.idUser !== idUser);
    const isBackoffice = window.self !== window.top;

    const credentialType = discountRequiredCredentials?.includes("otp") ? "otp" : "password";

    const discountData = {
        idTransaction: transaction?.idTransaction || "",

        title: transaction?.activityName,

        solicitante: `${transaction?.userCreatorFirstName} ${transaction?.userCreatorLastName}`,
        montoAcreditar: transaction?.data?.amount || { quantity: 0, currency: "ARS" },
        montoTotal: transaction?.data?.amountTotal || { quantity: 0, currency: "ARS" },

        accountId: transaction?.data?.account?.idProduct || "",
        echeqList: transaction?.data?.echeqList || [],
    };

    const data = {
        account: transaction?.data?.account,
        amount: {
            quantity: transaction?.data?.amount?.quantity ?? 0,
            currency: transaction?.data?.amount?.currency ?? "ARS",
        },
        amountTotal: {
            quantity: transaction?.data?.amountTotal?.quantity || 0,
            currency: transaction?.data?.amountTotal?.quantity || "ARS",
        },
        option: "discount.echeqs",
        idTransaction: transaction?.idTransaction,
        idActivity: transaction?.idActivity,
        isOwnEcheq: transaction?.data?.isOwnEcheq,
    };

    useEffect(() => {
        if (isBackoffice) {
            return;
        }
        if (!account?.accountType && discountData.accountId && !accountLabel) {
            dispatch(accountsActions.readAccount(discountData.accountId));
        } else if (!!account?.accountType && discountData.accountId && !accountLabel) {
            setAccountLabel(
                `${i18n.get(`productType.${account?.accountType}`, "")} ····${account?.accountNumber?.slice(-4)} ${
                    account?.accountType
                } ${i18n.get(`currency.label.${account?.currency}`, "")}` || "Error obteniendo la cuenta",
            );
        }
    }, [dispatch, account, discountData.accountId, accountLabel, setAccountLabel]);

    useEffect(() => {
        const validTransactionStatus = ["PENDING", "PROCESSING", "FINISHED", "FAILED"];
        if (validTransactionStatus.includes(discountTicketStatus) && discountTicketId) {
            gaEventTracker.triggerEvent(events.echeq_firmar());
            dispatch(routerActions.push(`/transaction/${discountTicketId}`));
        }
    }, [discountTicketStatus, discountTicketId]);

    useEffect(
        () => () => {
            dispatch(discountsActions.cleanDiscountTicket());
        },
        [],
    );

    const handleSignTransaction = (values) => {
        dispatch(
            discountsActions.createDiscount({
                account: transaction?.data?.account,
                [`_${credentialType}`]: values.credential,
                amount: {
                    quantity: transaction?.data?.amount?.quantity ?? 0,
                    currency: transaction?.data?.amount?.currency ?? "ARS",
                },
                amountTotal: {
                    quantity: transaction?.data?.amountTotal?.quantity || 0,
                    currency: transaction?.data?.amountTotal?.quantity || "ARS",
                },
                option: "discount.echeqs",
                idTransaction: transaction?.idTransaction,
                isOwnEcheq: transaction?.data?.isOwnEcheq,
            }),
        );
    };
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    return (
        <Fragment>
            <Notification scopeToShow="discounts" />
            {!isBackoffice && <ResponsiveHeader />}
            <MainContainer showLoader={isLoading}>
                <EcheqTransactionCard transaction={transaction}>
                    <EcheqTransactionHeader title={discountData.title} />
                    {/* <div className="ticket"> */}
                    <div className="ticket__wrapper">
                        <div className="ticket__header" />
                        <div className="ticket__body refills-transaction">
                            <div className="ticket-header-info">
                                <CustomData
                                    titleText={i18n.get("", "Solicitante")}
                                    valueText={discountData.solicitante}
                                />
                                <CustomData
                                    dataClass="amount tag tag-warning"
                                    titleText={i18n.get("", "Monto a acreditar")}
                                    valueText={discountData.montoAcreditar.quantity}
                                    valueTextType={discountData.montoAcreditar.currency}
                                />
                            </div>
                            <div className="view-more-data-button min-width-full-container">
                                <div className="ticket__divider inside-ticket__body">
                                    <div className="ticket__notch ticket__notch--left"> </div>
                                    <div className="ticket__notch ticket__notch--right"> </div>
                                </div>
                                <Button
                                    aria-expanded={showMoreData ? "true" : "false"}
                                    className="more-button"
                                    label={buttonLabel}
                                    bsStyle="link"
                                    onClick={handleSeeMoreData}
                                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                                />
                            </div>
                            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                <h2 className="col-span-full">{i18n.get("", "Datos adicionales")}</h2>
                                <div className="ticket-section four-cols">
                                    <CustomData
                                        titleText={i18n.get("", "Cuenta de acreditación")}
                                        valueText={accountLabel}
                                    />
                                    <CustomData
                                        titleText={i18n.get("", "Monto a negociar")}
                                        valueText={discountData.montoTotal.quantity}
                                        valueTextType={discountData.montoTotal.currency}
                                    />
                                    <CustomData
                                        titleText={i18n.get("", "Cantidad de Echeq")}
                                        valueText={finalEcheqs.length}
                                    />
                                    <CustomData titleText={i18n.get("", "Tasa")} valueText="" />
                                </div>
                                <div className="ticket__divider inside-ticket__body">
                                    <div className="ticket__notch ticket__notch--left"> </div>
                                    <div className="ticket__notch ticket__notch--right"> </div>
                                </div>
                                <h2>{i18n.get("", "Lote de documentos")}</h2>
                                <GridTable className="grid-table echeck-table tablelist col-span-full">
                                    {isDesktop && (
                                        <GridTable.Header>
                                            <GridTable.Container>
                                                <GridTable.Data columnStart={1} rowStart={1}>
                                                    <CustomText text={i18n.get("", "Recibido de")} />
                                                </GridTable.Data>
                                                <GridTable.Data columnStart={2} rowStart={1}>
                                                    <CustomText text={i18n.get("", "# Echeq")} />
                                                </GridTable.Data>
                                                <GridTable.Data columnStart={3} rowStart={1}>
                                                    <CustomText text={i18n.get("", "Fecha de emisión")} />
                                                </GridTable.Data>
                                                <GridTable.Data columnStart={4} rowStart={1}>
                                                    <CustomText text={i18n.get("", "Fecha de pago")} />
                                                </GridTable.Data>
                                                <GridTable.Data columnStart={5} rowStart={1}>
                                                    <CustomText text={i18n.get("", "Monto")} />
                                                </GridTable.Data>
                                            </GridTable.Container>
                                        </GridTable.Header>
                                    )}
                                    {finalEcheqs.map((echeq) => (
                                        <GridTable.Container>
                                            <GridTable.Data columnStart={1} rowStart={1} flexDirection="column">
                                                <CustomData
                                                    titleText={i18n.get("", "Recibido de")}
                                                    valueText={`CUIT ${echeq.emisor_cuit}`}
                                                />
                                                <div className="md:text-bold">{echeq.emisor_razon_social} </div>
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                <CustomData
                                                    titleText={i18n.get("", "# Echeq")}
                                                    valueText={echeq.cheque_numero}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={3} rowStart={1}>
                                                <CustomData
                                                    titleText={i18n.get("", "Fecha de emisión")}
                                                    valueText={echeq.fecha_emision}
                                                    valueTextType="DATE"
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={4} rowStart={1}>
                                                <CustomData
                                                    titleText={i18n.get("", "Fecha de pago")}
                                                    valueText={echeq.fecha_pago}
                                                    valueTextType="DATE"
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={5} rowStart={1}>
                                                <CustomData
                                                    titleText={i18n.get("", "Monto")}
                                                    valueText={echeq.monto}
                                                    valueTextType={echeq.emisor_moneda}
                                                />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    ))}
                                </GridTable>
                                <EcheqTransactionSign showSignatures />
                            </div>
                        </div>
                        <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                    </div>
                    {/* </div> */}
                </EcheqTransactionCard>
                <div className="box info border">
                    <CustomData
                        keepSpaceIfNoValue={false}
                        icon="images/figma/icon/info.svg"
                        titleText={i18n.get(
                            "",
                            `La solicitud se encontrará sujeta a aprobación crediticia de Bibank y tendrá
                            vigencia hasta las ${closingHour}:00 horas.
                            Vencido dicho plazo sin haber sido aceptada o rechazada por Bibank, deberá generarse nuevamente.`,
                        )}
                    />
                </div>

                {discountTicketSignable ? (
                    <Formik
                        // ref={(el) => setFormRef(el)}
                        validateOnBlur
                        validateOnChange={false}
                        initialValues={{
                            termAndConditions: false,
                        }}
                        validationSchema={Yup.object().shape({
                            termAndConditions: Yup.bool()
                                .test(
                                    "is-true",
                                    i18n.get("forms.inputFile.massivePayments.invalid.required"),
                                    (value) => !!value,
                                )
                                .required(i18n.get("forms.inputFile.massivePayments.invalid.required")),
                        })}
                        onSubmit={handleSignTransaction}>
                        {({ setFieldValue, values }) => (
                            <>
                                {/* <Row className="form-actions discounts-echeq-review__form-actions">
                                </Row> */}
                                <Row className="form-actions">
                                    <Col xs={12} md={10} lg={10} mdOffset={3}>
                                        <div className="discounts-echeq-review__form-actions">
                                            <Field
                                                component={Checkbox}
                                                idForm="discounts.new.lastForm"
                                                name="termAndConditions"
                                                labelText="discounts.new.review.termAndConditions.label"
                                                labelTextProps={{ defaultValue: "Aceptá los\u00A0" }}
                                            />
                                            <Button
                                                block
                                                className="btn btn-link discounts-echeq-review__form-actions-terms"
                                                onClick={() =>
                                                    setFieldValue(
                                                        "termAndConditions",
                                                        !values?.termAndConditions,
                                                        false,
                                                    )
                                                }
                                                defaultLabelText="Términos y Condiciones"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} md={10} mdOffset={1}>
                                        <GeneralCredentialForm
                                            transactionData={data}
                                            action={discountsActions.createDiscount}
                                            idActivity={
                                                data?.isOwnEcheq === true
                                                    ? "openLot.ownEcheq.send"
                                                    : "load.echeq.discounts"
                                            }
                                            hideIndications
                                            disableContinueIfEmpty
                                            isDisabled={values?.termAndConditions === false}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Formik>
                ) : (
                    <>
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={discountTicketSignable ? 2 : 4}>
                                <CustomButton
                                    func={() => dispatch(routerActions.push("/desktop"))}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className={`btn${discountTicketSignable ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                        </Row>
                    </>
                )}
            </MainContainer>
        </Fragment>
    );
};

NewDiscountPendingTransaction.propTypes = {
    transaction: shape({}).isRequired,
    isDesktop: bool.isRequired,
};

export default NewDiscountPendingTransaction;
